import { useEffect, useState } from "react";
import { collection, query, where, orderBy, onSnapshot, type QueryConstraint } from "firebase/firestore";
import { db } from "../firebase";
import { storedEntityTypes, withCurrentType } from "../types";
import type { Entity, EntityType } from "../types";

interface EntityWithId extends Entity {
  id: string;
}

interface UseEntitiesOptions {
  type?: EntityType;
  parentId?: string | null;
}

export function useEntities(options: UseEntitiesOptions = {}) {
  const [entities, setEntities] = useState<EntityWithId[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const constraints: QueryConstraint[] = [];

    if (options.type) {
      constraints.push(where("type", "in", storedEntityTypes([options.type])));
    }
    if (options.parentId !== undefined) {
      constraints.push(where("parentId", "==", options.parentId));
    }
    constraints.push(orderBy("displayName", "asc"));

    const q = query(collection(db, "entities"), ...constraints);

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) =>
        withCurrentType({ id: doc.id, ...doc.data() } as EntityWithId),
      );
      setEntities(data);
      setLoading(false);
    });

    return unsub;
  }, [options.type, options.parentId]);

  return { entities, loading };
}
